<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <el-col :span="12">
            <el-button
              size="small"
              icon="el-icon-plus"
              @click="add"
              v-access:add
              type="danger"
              >新增</el-button
            >
            <el-button
              size="small"
              icon="el-icon-download"
              @click="exportList"
              v-access:modify
              >导出</el-button
            >
          </el-col>
          <el-col :span="12" style="text=align: right">
            <div class="search-box">
              <el-input
                class="toolBar-search"
                v-model="searchModel.searchKey"
                :placeholder="placeholder"
              />
              <el-button
                size="small"
                icon="el-icon-search"
                type="danger"
                @click="loadData"
                >查询</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>

      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="donationStemCellModel"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
            prop="BusinessId"
            label="登记编号"
            width="200"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Name"
            label="姓名"
            width="100"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Sex"
            label="性别"
            width="60"
            align="center"
            :formatter="showSex"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Phone"
            label="手机号"
            width="110"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="IdType"
            label="证件类别"
            width="120"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template>{{ "身份证" }}</template>
          </el-table-column>
          <el-table-column
            prop="IdentityCard"
            label="身份证号码"
            width="180"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="MatchingStatue"
            label="状态"
            width="100"
            align="center"
            :formatter="showMatchingStatue"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Address"
            label="联系地址"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:modify
                @click="innerEdit(scope.row)"
                type="text"
                size="mini"
                >编辑</el-button
              >
              <el-button
                v-access:read
                @click="innerRead(scope.row)"
                type="text"
                size="mini"
                >详情</el-button
              >
              <!-- <el-button v-access:read type="text" size="mini">打印</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="searchModel.pageSize"
            :currentPage="searchModel.currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModelEdit
      v-if="editVisible"
      :id="editId"
      @formCallBack="formCallBack"
    ></ModelEdit>
    <ModelQuery
      v-if="queryVisible"
      :id="editId"
      @formCallBack="formCallBack"
    ></ModelQuery>
    <ModelAdd v-if="showAdd" @formCallBack="formCallBack"></ModelAdd>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import ModelEdit from "@/modules/zjrc/pages/donation/donationstemcell/edit";
import ModelQuery from "@/modules/zjrc/pages/donation/donationstemcell/query";
import api from "@/modules/zjrc/api";
import ModelAdd from "@/modules/zjrc/pages/donation/donationstemcell/add";
import { saveAs } from "file-saver";

export default {
  name: "list",
  data() {
    return {
      headerRow: "headerRow",
      placeholder: "请输入登记编号 / 姓名",
      donationStemCellModel: [], //造血干细胞
      isloading: false, //加载
      searchModel: { searchKey: "", currentPage: 1, pageSize: 15 },
      editVisible: false,
      queryVisible: false,
      editId: "", //编辑页Id
      total: 0,
      showAdd: false,
    };
  },
  components: {
    BasePage,
    OfPagination,
    ModelEdit,
    ModelQuery,
    ModelAdd,
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    //导出
    exportList() {
      const vm = this;
      saveAs(
        "/api/DonationStemCell/ExportDonationStemCell?searchKey=" +
          vm.searchModel.searchKey,
        "中心送检血样.xls"
      );
    },
    //新增
    add() {
      const vm = this;
      vm.showAdd = true;
    },
    //初始化数据
    loadData() {
      let that = this;
      let params = {
        SearchKey: that.searchModel.searchKey,
        PageIndex: that.searchModel.currentPage,
        PageSize: that.searchModel.pageSize,
      };
      that.isloading = true;
      api.QueryDonationStemCell(params).then((res) => {
        if (res.data.Code == 0) {
          that.donationStemCellModel = res.data.Data.rows;
        }
        that.isloading = false;
      });
    },
    //列表高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    //搜索框
    search(searchKey) {
      let that = this;
      that.searchModel.searchKey = searchKey;
    },
    //性别展示
    showSex(rowData) {
      return rowData.Sex == 0 ? "女" : "男";
    },
    showMatchingStatue(rowData) {
      switch (rowData.MatchingStatue) {
        case 0:
          return "采血样";
        case 1:
          return "入库";
        case 2:
          return "筛选";
        case 3:
          return "高分辨";
        case 4:
          return "体检";
        case 5:
          return "捐献成功";
        default:
          return "-";
      }
    },
    //编辑
    innerEdit(rowData) {
      let that = this;
      that.editId = rowData.Id;
      that.editVisible = true;
    },
    formCallBack(data) {
      let that = this;
      that.editVisible = false;
      that.queryVisible = false;
      that.showAdd = false;
      if (data) {
        that.loadData();
      }
    },
    //详情
    innerRead(rowData) {
      let that = this;
      that.editId = rowData.Id;
      that.queryVisible = true;
    },
    handleSizeChange(val) {
      this.searchModel.currentPage = 1;
      this.searchModel.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      if (this.total > this.searchModel.pageSize) {
        this.searchModel.currentPage = val;
        this.loadData();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.search-box {
  text-align: right;
  .toolBar-search {
    width: 300px;
    margin-right: 10px;
  }
}
</style>
